import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/customer-order/constants'


const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerOrderStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PENDING]    : 'warning',
    [STATUS.PROCESSING] : 'info',
    [STATUS.SHIPPED]    : 'primary',
    [STATUS.COMPLETED]  : 'success',
    [STATUS.CANCELLED]  : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerOrderStatusBadge.propTypes = propTypes

export default CustomerOrderStatusBadge